import LocationsApiService from './_services/locations.api.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    locations: [],
  },
  mutations: {
    [MutationTypes.SET_LOCATIONS](state, payload) {
      state.locations = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_LOCATIONS]({ commit }) {
      commit(MutationTypes.SET_LOCATIONS, await LocationsApiService.getLocations());
    },
  },
};
